<div class="container-termos-uso h-100">
    <div class="head d-flex justify-content-between align-items-start">
        <div class="col-8">
            <h1>{{ 'termosUso.dialog.title' | transloco }}</h1>
        </div>
        <button
            type="button"
            mat-icon-button
            (click)="fechar(false)"
            [attr.aria-label]="'termosUso.dialog.closeAriaLabel' | transloco"
        >
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="middle" (scroll)="onScroll($event)" [innerHTML]="'termosUso.bodyHtml' | transloco"></div>

    <div class="footer d-flex flex-row justify-content-between">
        <div class="my-3">
            <mat-checkbox [(ngModel)]="agreed">
                {{ 'termosUso.dialog.acceptLabel' | transloco }}
            </mat-checkbox>
        </div>

        <div class="my-3">
            <div class="d-flex justify-content-end">
                <button mat-stroked-button (click)="fechar(true)" [disabled]="!agreed" class="m-2">
                    {{ 'termosUso.dialog.submit' | transloco }}
                </button>
            </div>
        </div>
    </div>
</div>
